"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchLimitSucceeded = getFetchLimitSucceeded;
exports.getComfirmVideoUploadWithoutEmbedAction = getComfirmVideoUploadWithoutEmbedAction;
exports.getDecreaseVideoQuantityUsedAction = getDecreaseVideoQuantityUsedAction;
exports.confirmVideoUploadWithoutEmbed = exports.fetchLimits = void 0;

var LimitsApi = _interopRequireWildcard(require("../api/Limits"));

var _ActionTypes = require("./ActionTypes");

var _logging = require("../utils/logging");

function getFetchLimitSucceeded(limits) {
  return {
    type: _ActionTypes.FETCH_LIMITS_SUCCEEDED,
    limits: limits
  };
}

var fetchLimits = function fetchLimits() {
  return function (dispatch) {
    return LimitsApi.fetchLimits().then(function (limits) {
      return dispatch(getFetchLimitSucceeded(limits));
    }).catch(function (e) {
      (0, _logging.reportError)(e, {
        action: 'FETCH_LIMITS_FAILED'
      });
    });
  };
};

exports.fetchLimits = fetchLimits;

function getComfirmVideoUploadWithoutEmbedAction() {
  return {
    type: _ActionTypes.CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED
  };
}

var confirmVideoUploadWithoutEmbed = function confirmVideoUploadWithoutEmbed() {
  return function (dispatch) {
    dispatch(getComfirmVideoUploadWithoutEmbedAction());
  };
};

exports.confirmVideoUploadWithoutEmbed = confirmVideoUploadWithoutEmbed;

function getDecreaseVideoQuantityUsedAction(videoCount) {
  return {
    type: _ActionTypes.DECREASE_VIDEO_QUANTITY_USED,
    videoCount: videoCount
  };
}